import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subject, Subscription, EMPTY } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { config } from '../../../config/index';

import { PaginationComponent } from '../shared/components/pagination/pagination.component';

import { StatementsService } from './statements.service';
import { SessionStorageService } from '../shared/services/session-storage.service';
import { SnackbarService } from "../shared/services/snackbar.service";

@Component({
    template: require('./statements.component.html'),
    styles: [require('./statements.component.less')],
    providers: [StatementsService, SnackbarService]
})

export class StatementsComponent implements OnInit {

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;

    itemsPerPage: number = 10;
    page: number = 0;
    endCount: number;
    startCount: number;
    master: number;
    paginationItems: any;
    selectedType: any;
    order: string;
    loading: boolean = true;
    roleName: any;
    role = config.role;
    all_statements_list: any = [];
    statementFileTotalCount: number = 0;
    currency: any;

    apiSubscription: Subscription;
    fetchStatementApiSubscription: Subscription;
    inputSubscription: Subscription;
    limitInputSub$: Subject<string> = new Subject<string>();

    constructor(
        private _statementsService: StatementsService,
        private _mdlSnackbarService: SnackbarService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _sessionStorageService: SessionStorageService
    ) { }

    getStatementsList(itemsPerPage: any, page: any) {
        this.loading = true;
        this.itemsPerPage = itemsPerPage;
        this.page = page;
        this.apiSubscription = this._statementsService.getStatementsList(itemsPerPage, page)
            .subscribe(res => this.getstatementsSuccessHandler(res),
                error => this.getStatementsListErrorHandler(error));
    }

    getStatementsListErrorHandler(error: any) {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
    }

    /**
     * Function to set items Per page value
     * @param  {any} limitValue
     * @param  {any} event
     */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.itemsPerPage = this.paginationItems.passedItems;
            this.page = this.paginationItems.reqOffset;
            this.getStatementsList(this.paginationItems.passedItems, this.paginationItems.reqOffset);
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.statementFileTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        this.itemsPerPage = event.itemsPerPage;
        this.page = event.offset;
        if (event.isClicked) {
            this.getStatementsList(event.itemsPerPage, event.offset);
        }
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    ngOnInit() {
        this.getStatementsList(10, 0);
        this.selectedType = 10;
        this._sessionStorageService.readItem(this.role).then((data: any) => this.roleName = data.role);

        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();
    }

    getstatementsSuccessHandler(res: any) {
        if (!res.data) {
            this.all_statements_list = [];
        } else {
            this.all_statements_list = res.data;
            this.currency = config.currency['USD'];
        }

        this.statementFileTotalCount = res.count;
        if (this.page >= 0) {
            if (this.all_statements_list.length !== 0) {
                this.startCount = this.page + 1;
                this.endCount = this.startCount + this.all_statements_list.length - 1;
            } else {
                this.startCount = 0;
                this.endCount = 0;
            }
        }
        this.loading = false;
    }

    fetchStatement(id: any, download: boolean) {
        this.loading = true;
        this.fetchStatementApiSubscription?.unsubscribe();
        this.fetchStatementApiSubscription = this._statementsService.getStatementPdf(id)
            .subscribe(res => {
                this.loading = false;
                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(res, "Statement-" + id + "-" + new Date().getTime() + ".pdf");
                } else {
                    var blob = res;
                    var link = document.createElement('a');
                    var binaryData: any = [];
                    binaryData.push(blob);
                    link.href = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
                    if (download) {
                        link.download = "Statement-" + id + "-" + new Date().getTime() + ".pdf";
                        // append the link to the document body
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                    } else {
                        window.open(link.href, '_blank');
                    }
                }
            },
                error => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    ngOnDestroy() {
        this.apiSubscription?.unsubscribe();
        this.fetchStatementApiSubscription?.unsubscribe();
        this.inputSubscription?.unsubscribe();
    }

}
